import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { AuthenticationManager } from './authenticationManager';
import { Router } from '@angular/router';
import { environment } from '../../../../../src/environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private router: Router, private authService: AuthenticationService, private authenticationManager: AuthenticationManager, private injector: Injector) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authenticate = this.authenticationManager.getAuthenticate();

    const isPublicApi = req.url.startsWith(`${environment.gateway_url}auth/`);
    // const isPublicApi = req.url.includes('/api/v1/auth/');
    if (authenticate && !isPublicApi) {
      //console.log("Not a public api................")
      const accessToken = authenticate.accessToken;
      const checksum = authenticate.token;
      let authReq = req;
      if (accessToken) {
        authReq = this.addToken(req, accessToken, btoa(checksum));
      }
      return next.handle(authReq).pipe(
        catchError(err => {
          if (this.isAccessDenied(err)) {
            return throwError(() => err);
          }
          if ((err.status === 401 || err.status === 403) && !req.url.includes('/api/v1/auth/refreshToken')) {
            return this.handle401Error(req, next);
          }
          // this.router.navigate(['/login']);
          // this.isRefreshing = false;
          // sessionStorage.clear();
          // localStorage.clear();
          return throwError(() => err);
        })
      );
    }
    return next.handle(req);
  }

  private isAccessDenied(err: any): boolean {
    const body = err?.error;
    if (body && body.accessDenied === true) {
      return true;
    }
    const text = typeof body === 'string' ? body : (body?.resultDescription || '');
    return String(text).toLowerCase().includes("don't have access");
  }

  private addToken(req: HttpRequest<any>, token: string, checksum: string): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}`, 'Checksum': checksum } });
  }

  private handle401Error(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authenticate = this.authenticationManager.getAuthenticate();

    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const refToken = {
        token: authenticate.token
      };
      return this.authService.refreshToken(refToken).pipe(
        // switchMap((res: any) => {
        //   this.isRefreshing = false;
        //   this.refreshTokenSubject.next(res.data.accessToken);
        //   return next.handle(this.addToken(req, res.data.accessToken, btoa(res.data.token)));
        // }),



        switchMap((res: any) => {
          this.isRefreshing = false;

          // Update the stored token and accessToken
          const updatedAuth = {
            ...authenticate,
            accessToken: res.data.accessToken,
            token: res.data.token
          };
          this.authenticationManager.saveAuth(updatedAuth);

          this.refreshTokenSubject.next(res.data.accessToken);
          return next.handle(this.addToken(req, res.data.accessToken, btoa(res.data.token)));
        }),

        catchError(error => {
          this.router.navigate(['/login']);
          this.isRefreshing = false;
          sessionStorage.clear();
          localStorage.clear();
          return throwError(() => error);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null),
        take(1),
        switchMap(token => next.handle(this.addToken(req, token!, btoa(authenticate.token))))
      );
    }
  }
  

}

